import React, { Fragment } from 'react';
import LeftMenu from './LeftMenu/LeftMenu';
import TopMenu from '../TopMenu/TopMenu';
import { Switch, Route } from 'react-router';
import Notifications from '../../common/components/Notification';
import Home from './Home/Home';

const Driver: React.FC = () => {
  return (
    <Fragment>
      <Notifications />
      <LeftMenu />
      <div id='content-wrapper' className='d-flex flex-column'>
        <div id='content'>
          <TopMenu />
          <div className='container-fluid'>
            <Switch>
              <Route path='/'>
                <Home/>
              </Route>
            </Switch>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Driver;
